<div class="product-view-wrapper">
    <div class="small-view">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" >
            <div ngxSlickItem *ngFor="let slide of slides | slice:0:4" class="slide">
                <div class="img-wrapper">
                    <img src="{{ slide.img }}" alt="" width="100%">
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="large-view">
        <ngx-slick-carousel class="carousel1" #slickModal="slick-carousel" [config]="slideConfig2">
            <div ngxSlickItem *ngFor="let slide2 of slides2 | slice:0:4" class="slide">
                <div class="img-wrapper">
                    <div class="img-height">
                        <img src="{{ slide2.img }}" alt="" width="100%">
                    </div>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
</div>